import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgForm, UntypedFormControl } from '@angular/forms';
import { SecurityService } from 'app/shared/security.service';
import { Select2Option } from '../../shared/select2-option';
@Component({
    selector: 're-edit-username-dialog',
    templateUrl: './edit-username-dialog.component.html',
    styleUrls: ['./edit-username-dialog.component.scss'],
    standalone: false
})
export class EditUsernameDialogComponent {
  @ViewChild("form")
  form: NgForm;

  newUsername: string = '';
  selectedDomain: string = 'No valid domain found';

  usernameDomains: string[];
  domainOptions: Select2Option[] = [];

  constructor(private activeModal: NgbActiveModal, private router: Router,  private secSvc: SecurityService) { }

  async ngOnInit(): Promise<void> {
    this.usernameDomains = await this.secSvc.getAvailableDomains();
    this.domainOptions = this.usernameDomains.map(x => { return { text: "@"+x, id: x } });
    if(this.domainOptions.length > 0) {
      this.selectedDomain = this.usernameDomains[ 0 ];
    }
  }

  updateUsername() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }
}
